import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import moment from 'moment'

import Icon from '@components/Icon'
import Button from '@components/Button'
import DatePicker from 'shared/components/TimePicker/DatePicker'
import { DATE_FORMAT } from 'shared/constants'

import { getAllSurveyAdmin, getSurveyTextAnswer } from '../../selectors'
import { getAllSurveysByCountryAdmin, getSurveyTextAnswersById } from '../../actions'

import SurveyDetails from '../Dashboard/SurveyDetails'
import SurveyDataView from '../Dashboard/SurveyDataView'

import styles from '../styles.module.scss'

const DetailsView = ({ survey, onClick, textAnswers, getSurveyTextAnswersById }) => {
    const [page, setPage] = useState(1)

    useEffect(() => {
        getSurveyTextAnswersById(survey.surveyId)
    }, [])

    return (
        <>
            <div className={classNames('container', styles.npsContent)}>
                <div className={styles.detailsNav}>
                    <Button className="" size="small" btnStyle="link" onClick={onClick}>
                        <T>nps.admin.main.menu.history.sectionHeading</T>
                    </Button>
                    <Icon type={'separator'} size="xxxs" className={styles.arrowIcon} />
                    <span>{survey.name}</span>
                </div>
                <h1 className={styles.npsContainerTitle}>{survey.name}</h1>
                <div className="d-flex justify-content-center">
                    <DatePicker
                        label={'Survey start date '}
                        name="startDate"
                        className={classNames('d-flex align-items-center', styles.datePickerReadOnly)}
                        value={moment(survey.dateStart)}
                        displayFormat={DATE_FORMAT}
                        readOnly
                    />
                    <DatePicker
                        name="dateEnd"
                        label={'Survey end date '}
                        className={classNames('d-flex align-items-center', styles.datePickerReadOnly)}
                        value={moment(survey.dateEnd)}
                        displayFormat={DATE_FORMAT}
                        readOnly
                    />
                </div>
                <SurveyDetails surveyResults={survey} />
                <SurveyDataView survey={survey} textAnswers={textAnswers} page={page} setPage={setPage} />
            </div>
        </>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            allSurvey: getAllSurveyAdmin,
            textAnswers: getSurveyTextAnswer,
        }),
        { getAllSurveysByCountryAdmin, getSurveyTextAnswersById }
    )
)(DetailsView)
